import * as React from 'react';
import { Book } from 'src/models/Book';
import { FavouritePrintModel } from 'src/models/UserContent';

import { Convert, ResourcePlatform } from './Helpers';

export interface IFavouritePrintProps {
  model: FavouritePrintModel;
  context: Book;
  underline?: boolean;
  omitNotes?: boolean;
}
export interface IFavouritePrintState {}
export class FavouritePrint extends React.PureComponent<IFavouritePrintProps, IFavouritePrintState> {
  constructor(props: IFavouritePrintProps) {
    super(props);
  }
  render() {
    let excerpts: JSX.Element[] = [];
    excerpts.push(<span>...</span>);
    this.props.model.Excerpts.map((item) => {
      if (item.IsHighlight) {
        if (this.props.underline === true) {
          excerpts.push(
            <span style={{ textDecoration: "underline", textDecorationThickness: "3px" }}>
              {item.Content}
            </span>
          );
        } else {
          excerpts.push(<span>{item.Content}</span>);
        }
      } else {
        excerpts.push(<span>{item.Content}</span>);
      }
    });
    excerpts.push(<span>...</span>);
    return (
      <div className="annoContainer">
        <h3>
          {this.props.context.localization.currentLocale.AnnotationView.LABEL_DATE}:{" "}
          {Convert.dateToFormattedString(this.props.model.Favourite.LastUpdate, this.props.context.localization.currentCulture)}
        </h3>
        <h4>{this.props.model.BreadCrumbs}</h4>
        {this.props.omitNotes !== true && !Convert.isEmptyOrSpaces(this.props.model.Favourite.Value) && (
          <div className="noteBox">
            {ResourcePlatform.toMarkdown(
              this.props.model.Favourite.Value,
              () => {},
              () => ""
            )}
          </div>
        )}
        <div className="annoExcerpts">
          <p>{excerpts}</p>
        </div>
      </div>
    );
  }
}

